// extracted by mini-css-extract-plugin
export var danger = "_3s-6";
export var lightPink = "_3s-a";
export var medium = "_3s-j";
export var nearSquare = "_3s-m";
export var neutralBlue = "_3s-8";
export var neutralYellow = "_3s-7";
export var noCapitalize = "_3s-1";
export var normal = "_3s-2";
export var pill = "_3s-0";
export var primary = "_3s-3";
export var primaryLight = "_3s-4";
export var shadow = "_3s-n";
export var small = "_3s-k";
export var solidBlack = "_3s-i";
export var solidGreen = "_3s-d";
export var solidLightBlue = "_3s-f";
export var solidNavy = "_3s-e";
export var solidOrange = "_3s-h";
export var solidPink = "_3s-g";
export var solidRed = "_3s-b";
export var solidWhite = "_3s-9";
export var solidYellow = "_3s-c";
export var success = "_3s-5";
export var xsmall = "_3s-l";